const constants = {
    "API_URL": window.REACT_APP_API_URL,
    "WS_KEY": window.REACT_APP_WS_KEY,
    "WS_CLUSTER": window.REACT_APP_WS_CLUSTER
};

export default constants;
